import type { SiteType } from '../types/schema';
import { normalizeReturnToPath } from '../utils/portalPath';

const RETURN_TO_KEY = 'microsites-auth-return-to';

export function saveReturnTo(returnTo: string): void {
  const normalizedReturnTo = normalizeReturnToPath(returnTo);
  if (!normalizedReturnTo) {
    return;
  }

  sessionStorage.setItem(RETURN_TO_KEY, normalizedReturnTo);
}

export function getReturnTo(): string | null {
  return normalizeReturnToPath(sessionStorage.getItem(RETURN_TO_KEY));
}

export function clearReturnTo(): void {
  sessionStorage.removeItem(RETURN_TO_KEY);
}

// Parses the siteType out of a returnTo path (e.g. /enrollments/form or
// /escalations/form) so the verify page can scope draft restoration correctly.
export function extractSiteType(path: string | null | undefined): SiteType | null {
  if (!path) return null;
  const segments = path.split('/').filter(Boolean);
  if (segments.includes('enrollments')) return 'enrollments';
  if (segments.includes('escalations')) return 'escalations';
  return null;
}


